/* ============================================================
   <cpfs-allergens> — per-variant allergen/ingredient panels
   (sections/cpfs-product-allergens.liquid).

   Declarations are variant-level, and the allergens section sits
   OUTSIDE Dawn's main product section, so the Section Rendering
   API re-render on variant change never reaches it. The section
   server-renders one panel per variant that has data; this element
   rides PUB_SUB_EVENTS.variantChange (same pattern as
   <cpfs-orderable-cta> in cpfs-product.js) to show the matching
   panel — and hides the entire section when the chosen variant has
   no declaration, matching the PDP rule that missing info is
   hidden, never shown as "pending".

   Single-variant products never fire the event; the server-rendered
   state stands. No pubsub on the page = no behaviour, no breakage.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('cpfs-allergens')) return;

  customElements.define(
    'cpfs-allergens',
    class CpfsAllergens extends HTMLElement {
      connectedCallback() {
        // Every variant id of THIS product (including variants without a
        // panel), so variantChange events from other products on the page
        // are ignored, while a data-less sibling variant still hides the
        // section instead of being mistaken for a foreign product.
        this.variantIds = (this.dataset.variantIds || '').split(',').filter(Boolean);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        if (this._unsubscribe) this._unsubscribe();
      }

      onVariantChange(event) {
        var data = event && event.data;
        if (!data || !data.variant || !data.variant.id) return;
        var id = String(data.variant.id);
        if (this.variantIds.indexOf(id) === -1) return; // another product's variant

        var match = null;
        this.querySelectorAll('[data-allergens-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-allergens-panel') === id;
          panel.hidden = !active;
          if (active) match = panel;
        });

        var section = this.closest('[data-cpfs-allergens]');
        if (section) section.hidden = !match;
      }
    },
  );
})();
